import React from 'react';
import { Link } from 'react-router-dom';
import { StampIcon, ArrowRight, Clock, ShieldCheck, FileCheck2 } from 'lucide-react';
import { visas, flagUrl, priceText } from '../visaData';

export default function VisaStrip() {
  return (
    <section id="visas" className="py-20 md:py-24 bg-[#0B2545] relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.06] bg-cover bg-center" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=1600&q=60')" }} />
      <div className="relative max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-2 gap-12 items-center">
        <div className="reveal">
          <p className="section-eyebrow text-[#ff9a6a] mb-3"><span className="h-px w-8 bg-[#EA5019] inline-block" /> VISA SERVICES</p>
          <h2 className="font-heading text-3xl md:text-4xl font-extrabold text-white leading-tight flex items-center gap-3">
            <StampIcon className="text-[#ff7a45]" size={34} /> Visas Made Simple
          </h2>
          <p className="mt-4 text-white/75 leading-relaxed max-w-md">Transparent pricing, expert documentation help and quick processing. Apply online in a few easy steps and travel worry-free.</p>
          <div className="mt-7 flex flex-wrap gap-6 text-white/85 text-sm">
            <span className="flex items-center gap-2"><ShieldCheck size={18} className="text-[#ff7a45]" /> Secure online payment</span>
            <span className="flex items-center gap-2"><FileCheck2 size={18} className="text-[#ff7a45]" /> Document assistance</span>
            <span className="flex items-center gap-2"><Clock size={18} className="text-[#ff7a45]" /> Fast processing</span>
          </div>
          <Link to="/visas" data-testid="home-visas-cta" className="mt-8 inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-[#EA5019] text-white font-semibold hover:bg-[#cf4413] transition-all shadow-[0_12px_30px_rgba(234,80,25,0.4)] hover:-translate-y-1 duration-200">
            Explore All Visas <ArrowRight size={18} />
          </Link>
        </div>

        <div className="reveal grid sm:grid-cols-2 gap-4">
          {visas.slice(0, 4).map((v) => (
            <Link
              key={v.slug}
              to={`/visas/${v.slug}`}
              data-testid={`home-visa-${v.slug}`}
              className="group rounded-2xl bg-white/5 border border-white/10 p-5 hover:bg-white/10 hover:-translate-y-1 transition-all duration-300 backdrop-blur-sm"
            >
              <div className="flex items-center gap-3 mb-3">
                <img src={flagUrl(v.countryCode)} alt={`${v.country} flag`} className="h-7 w-10 object-cover rounded shadow" />
                <div>
                  <h3 className="font-heading font-bold text-white leading-tight">{v.country}</h3>
                  <span className="text-white/60 text-xs">{v.visaType}</span>
                </div>
              </div>
              <div className="flex items-center justify-between">
                <span className="text-white/80 text-sm">from <span className="font-heading font-extrabold text-[#ff9a6a]">{priceText(v)}</span></span>
                <span className="inline-flex items-center gap-1 text-[#ff9a6a] text-sm font-semibold group-hover:gap-2 transition-all">Apply <ArrowRight size={14} /></span>
              </div>
            </Link>
          ))}
          <Link to="/visas" className="sm:col-span-2 text-center rounded-2xl border border-dashed border-white/20 py-3 text-white/70 hover:text-white hover:border-white/40 transition text-sm font-medium">
            + View all {visas.length} visa destinations
          </Link>
        </div>
      </div>
    </section>
  );
}
